// extracted by mini-css-extract-plugin
export var container = "_a0-0";
export var containerTopRight = "_a0-1";